import { default as pjson } from '../package.json';

export const AppVersion = {
    FIELDTEC_APP_VERSION: pjson.version
};
